import { NotFound } from "@dgs/core";
import { Route, Routes } from "react-router";
import { AccessDeniedList } from "../shared/ui/AccessDeniedList";
import { useGlobalTenants } from "../tenants/global/GlobalTenantProvider";
import { DistributionListList } from "./DistributionListList";
import { DistributionListViewPage } from "./DistributionListViewPage";

export const DistributionListPage = () => {
	const { selected } = useGlobalTenants();

	if (!selected.tenant) {
		return <AccessDeniedList />;
	}

	return (
		<Routes>
			<Route index element={<DistributionListList />} />
			<Route path=":id" element={<DistributionListViewPage />} />
			<Route path="*" element={<NotFound />} />
		</Routes>
	);
};
